/**
 * Background job platform endpoints
 */

import { fetchApi } from '../core';
import type { BackgroundJobListResponse } from '../types';

export function listBackgroundJobs(componentName: string = 'Unknown') {
  return fetchApi<BackgroundJobListResponse>(
    '/platform/background-jobs',
    {},
    componentName
  );
}
